var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.89 10.636h3.276V7.844H4.89v2.792zm4.012 1.358H4.154c-.406 0-.736-.303-.736-.679V7.164c0-.375.33-.679.736-.679h4.748c.406 0 .735.304.735.679v4.151c0 .376-.33.679-.735.679zM16.688 8.203H12.13c-.405 0-.735-.304-.735-.679 0-.375.33-.679.735-.679h4.56c.405 0 .735.304.735.68 0 .374-.33.678-.736.678M16.688 11.617H12.13c-.405 0-.735-.304-.735-.68 0-.374.33-.678.735-.678h4.56c.405 0 .735.304.735.679 0 .375-.33.679-.736.679M16.688 15.39H4.154c-.406 0-.736-.303-.736-.678 0-.376.33-.68.736-.68h12.534c.406 0 .736.304.736.68 0 .375-.33.679-.736.679M16.688 18.734H4.154c-.406 0-.736-.304-.736-.679 0-.375.33-.679.736-.679h12.534c.406 0 .736.304.736.68 0 .374-.33.678-.736.678",
    transform: "translate(-60 -166) translate(47 153) translate(13.153 13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47 1.358v20.383c0 1.367 1.204 2.48 2.683 2.48h15.774c-.36-.608-.556-1.4-.556-2.34V1.358h-17.9zm19.37 3.16v17.363c0 .873.202 2.34 1.544 2.34 1.047 0 2.114-.295 2.114-2.48V4.518H20.84zm1.544 21.061H4.154C1.863 25.58 0 23.857 0 21.741V.68C0 .304.33 0 .735 0h19.37c.408 0 .735.304.735.68v2.48h4.393c.406 0 .736.303.736.678v17.903c0 3.34-2.246 3.838-3.585 3.838z",
    transform: "translate(-60 -166) translate(47 153) translate(13.153 13)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActus);
export default __webpack_public_path__ + "static/media/actus.a6e62e83.svg";
export { ForwardRef as ReactComponent };